var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalIcoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pixelarticons:external-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 9.16667V2.5H10.8333V4.16667H14.1667V5.83333H12.5V7.5H10.8333V9.16667H9.16667V10.8333H7.5V12.5H9.16667V10.8333H10.8333V9.16667H12.5V7.5H14.1667V5.83333H15.8333V9.16667H17.5ZM9.16667 4.16667H2.5V17.5H15.8333V10.8333H14.1667V15.8333H4.16667V5.83333H9.16667V4.16667Z",
    fill: "#CDCDCD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalIcoPrimary);
export default __webpack_public_path__ + "static/media/external-ico-primary.0555a37aa280299b1e1b3c5dac272923.svg";
export { ForwardRef as ReactComponent };